export const routeTypes = [
  'miHintAdmin',
  'individual',
  'educational',
  'enterprise',
  'selectOrganization',
];
